import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, {useState} from 'react';

import {DownloadIcon} from '../../constants/icons';
import {pxToRem} from '../../utils';
import CustomButton from '../CustomButton/CustomButton';
import CustomSnackbar from '../CustomSnackBar/CustomSnackBar';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import Legend from '../Legend/Legend';
import SearchInput from '../SearchInput/SearchInput';

const StyledWrapperDiv = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(1, 0),
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const StyledRightDiv = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: pxToRem(32),
  fontWeight: 'bold',
  color: theme.palette.grey[700],
}));

const StyledCustomButton = styled(CustomButton)(({theme}) => ({
  minWidth: pxToRem(100),
}));

const ToolBar = ({
  headerText,
  showGlobalSearch,
  globalFilter,
  setGlobalFilter,
  showLegends,
  legends,
  showExportButton,
  showCustomButtons,
  getDataToExport,
  headerFontSize,
}) => {
  const [loading, setloading] = useState(false);

  const [snackbarAlert, setSnackBarAlert] = useState({isOpen: false, message: '', severity: 'warning'});

  const handleExportClick = () => {
    setloading(true);
    const data = getDataToExport();
    if (data) {
      const blob = new Blob([data.dataToExport], {type: 'application/json', encoding: 'UTF-8'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${data.fileName}.csv`;
      link.click();
    }
    setSnackBarAlert((prevState) => ({
      ...prevState,
      isOpen: true,
      message: `File Downloaded Successfully`,
      severity: 'success',
    }));
    setloading(false);
  };

  const closeSnackBarAlert = () => {
    setSnackBarAlert((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  };

  const information =
    'Export limited to filtered data. Please apply filters to select the specific data you wish to export';

  return (
    <StyledWrapperDiv>
      <StyledTypography sx={{fontSize: headerFontSize ? `${headerFontSize}px` : null}}>{headerText}</StyledTypography>
      <StyledRightDiv>
        {showGlobalSearch ? (
          <Box sx={{width: pxToRem(300)}}>
            <SearchInput placeholderText={'search...'} value={globalFilter} onChange={setGlobalFilter} debounce={500} />
          </Box>
        ) : null}
        {showLegends
          ? legends.map((legend, index) => {
              return <Legend key={index} label={legend?.label} data={legend?.data} textColor={legend?.textColor} />;
            })
          : null}
        {showExportButton?.button && (
          <Box sx={{marginLeft: pxToRem(8)}}>
            {showExportButton?.tooltip && <InfoTooltip information={information} color={'primary'} />}
            <StyledCustomButton
              text={
                <>
                  <DownloadIcon />
                  <span>Export</span>
                </>
              }
              isLoading={loading}
              onClick={handleExportClick}
            />
          </Box>
        )}
        {showCustomButtons?.map((showCustomButton) => {
          return (
            showCustomButton?.button && (
              <Box sx={{marginLeft: pxToRem(8)}} key={showCustomButton.text}>
                {showCustomButton?.tooltip && <InfoTooltip information={information} color={'primary'} />}
                <StyledCustomButton
                  text={
                    <>
                      <showCustomButton.icon />
                      <span>{showCustomButton.text}</span>
                    </>
                  }
                  onClick={showCustomButton?.onClick}
                  menuItems={showCustomButton?.menuItems}
                />
              </Box>
            )
          );
        })}
      </StyledRightDiv>
      {snackbarAlert && (
        <CustomSnackbar
          autoHideDuration={5000}
          message={snackbarAlert.message}
          isOpen={snackbarAlert.isOpen}
          showCloseButton={true}
          handleClose={closeSnackBarAlert}
          isAlert={true}
          severity={snackbarAlert?.severity}
          anchorOriginVertical={'bottom'}
        />
      )}
    </StyledWrapperDiv>
  );
};

export default ToolBar;
